<template>
    <div>
        <div class="header">
            <div class="step-ttl">تحصیلات</div>
            <div class="h-border"></div>
            <div class="step">مرحله 2-4</div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="header-row">
                    <div class="content"><label>نام كامل دانشگاه‌:</label></div>
                    <div class="content"><label>مدرك تحصیلی‌:</label></div>
                    <div class="content"><label>رشته تحصیلی‌:</label></div>
                    <div class="content"><label>تاريخ شروع‌:</label></div>
                    <div class="content"><label>تاريخ پايان‌:</label></div>
                    <div class="content"><label>معدل‌:</label></div>
                </div>
            </div>
        </div>
        <div class="field_wrapper">
            <div class="row">
                <div class="col-md-12">
                    <div class="body-row" v-for="(item, index) in educationInfos" :key="index">
                        <div class="content">
                            <input type="text"
                                   v-model="$v.educationInfos.$each[index].instituteName.$model"
                                   @input="$v.educationInfos.$each[index].instituteName.$touch()"
                                   :class="[$v.educationInfos.$each[index].instituteName.$error && !$v.educationInfos.$each[index].instituteName.required ?'error-input' :'','form-control']">
                            <span class="help-block" v-if="$v.educationInfos.$each[index].instituteName.$error && !$v.educationInfos.$each[index].instituteName.required">لطفا نام كامل دانشگاه را وارد کنید.</span>
                        </div>
                        <div class="content">
                            <select v-model="$v.educationInfos.$each[index].degree.$model"
                                    @input="$v.educationInfos.$each[index].degree.$touch()"
                                    :class="[$v.educationInfos.$each[index].degree.$error && !$v.educationInfos.$each[index].degree.required ?'error-input' :'','form-control']">
                                <option value="1">دیپلم</option>
                                <option value="2">کاردانی</option>
                                <option value="3">کارشناسی</option>
                                <option value="4">کارشناسی ارشد</option>
                                <option value="5">دکتری</option>
                            </select>
                            <span class="help-block" v-if="$v.educationInfos.$each[index].degree.$error && !$v.educationInfos.$each[index].degree.required">لطفا مدرك تحصیلی را انتخاب کنید.</span>
                        </div>
                        <div class="content">
                            <input type="text"
                                   v-model="$v.educationInfos.$each[index].fieldOfStudy.$model"
                                   @input="$v.educationInfos.$each[index].fieldOfStudy.$touch()"
                                   :class="[$v.educationInfos.$each[index].fieldOfStudy.$error && !$v.educationInfos.$each[index].fieldOfStudy.required ?'error-input' :'','form-control']">
                            <span class="help-block" v-if="$v.educationInfos.$each[index].fieldOfStudy.$error && !$v.educationInfos.$each[index].fieldOfStudy.required">لطفا رشته تحصیلی را وارد کنید.</span>
                        </div>
                        <div class="content">
                            <input type="text"
                                   v-model="$v.educationInfos.$each[index].startDate.$model"
                                   @input="$v.educationInfos.$each[index].startDate.$touch()"
                                   placeholder="مثال: 1390/01/15"
                                   :class="[$v.educationInfos.$each[index].startDate.$error && !$v.educationInfos.$each[index].startDate.required ?'error-input' :'','form-control']">
                            <span class="help-block" v-if="$v.educationInfos.$each[index].startDate.$error && !$v.educationInfos.$each[index].startDate.required">لطفا تاريخ شروع را وارد کنید.</span>
                        </div>
                        <div class="content">
                            <input type="text"
                                   v-model="$v.educationInfos.$each[index].endDate.$model"
                                   @input="$v.educationInfos.$each[index].endDate.$touch()"
                                   placeholder="مثال: 1390/01/15"
                                   :class="[$v.educationInfos.$each[index].endDate.$error && !$v.educationInfos.$each[index].endDate.required ?'error-input' :'','form-control']">
                            <span class="help-block" v-if="$v.educationInfos.$each[index].endDate.$error && !$v.educationInfos.$each[index].endDate.required">لطفا تاريخ پايان را وارد کنید.</span>
                        </div>
                        <div class="content">
                            <input type="text"
                                   v-model="$v.educationInfos.$each[index].rate.$model"
                                   @input="$v.educationInfos.$each[index].rate.$touch()"
                                   :class="[$v.educationInfos.$each[index].rate.$error && !$v.educationInfos.$each[index].rate.required ?'error-input' :'','form-control']">
                            <span class="help-block" v-if="$v.educationInfos.$each[index].rate.$error && !$v.educationInfos.$each[index].rate.required">لطفا معدل را وارد کنید.</span>
                        </div>
                        <div class="action-btn" v-if="index !=0">
                            <a href="javascript:void(0);"
                               class="remove_rowbtn"
                               @click="removeEducationInfoRow(index)"
                               title="حذف این سطر"><i class="avafont-minus"></i></a>
                        </div>
                    </div>
                    <div class="action-btn action-btn-pos">
                        <a href="javascript:void(0);"
                           @click="addNewEducationInfoRow()"
                           class="add_rowbtn"
                           v-if="educationInfos.length<=3"
                           title="افزودن سطر جدید"><i class="avafont-add"></i></a>
                    </div>
                </div>
            </div>
        </div>
        <div class="header">
            <div class="step-ttl">سوابق كاری</div>
            <div class="h-border"></div>
        </div>
        <div v-for="(workHistory, index) in workHistories" :key="'workHistory'+index">
            <div class="sub-header" v-if="index==0">
                <div class="step-ttl">محل كار كنونی/آخرين محل كار</div>
                <div class="h-border"></div>
            </div>
            <div class="sub-header" v-if="index==1">
                <div class="step-ttl">محل كار قبلی</div>
                <div class="h-border"></div>
            </div>
            <hr v-if="index==2" />
            <div class="action-btn d-flex justify-content-end">
                <a href="javascript:void(0);"
                   class="remove_rowbtn"
                   v-if="index==2"
                   @click="removeWorkHistory"
                   title="حذف این فرم" id="remove-new-form"><i class="avafont-minus"></i></a>
            </div>
            <div class="row relative">
                <div class="col-md-3">
                    <div class="form-group">
                        <label>نام شرکت:</label>
                        <input type="text" v-model="workHistory.companyName" />
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>زمینه فعالیت شرکت:</label>
                        <input type="text" v-model="workHistory.companyFieldOfActivity" />
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>سمت/شغل‌:</label>
                        <input class="form-control" type="text" v-model="workHistory.post">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>تعداد کارکنان:</label>
                        <input class="form-control" type="text" v-model="workHistory.employeesCount">
                    </div>
                </div>
                <div class="action-btn action-btn-pos">
                    <a href="javascript:void(0);"
                       @click="addWorkHistory"
                       v-if="workHistories.length==2 && index==1"
                       class="add_rowbtn" title="افزودن اطلاعات بیش تر"><i class="avafont-add"></i></a>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <div class="form-group">
                        <label>تاریخ شروع همکاری:</label>
                        <input class="form-control" type="text" v-model="workHistory.startOfWork" placeholder="مثال: 1390/08/15">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>تاریخ پایان همکاری:</label>
                        <input class="form-control" type="text" v-model="workHistory.endOfWork" placeholder="مثال: 1393/08/15">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>نام سرپرست/مدیر مستقیم‌:</label>
                        <input class="form-control" type="text" v-model="workHistory.bossName">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>علت خاتمه/تمايل به خاتمه همكاری:</label>
                        <input class="form-control" type="text" v-model="workHistory.reasonOfTerminationOfCooperation">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <div class="form-group">
                        <label>حقوق و مزايای اولیه:</label>
                        <input class="form-control" type="text" v-model="workHistory.primarySalaryAndBenefits">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label>آخرين حقوق و مزايا:</label>
                        <input class="form-control" type="text" v-model="workHistory.lastSalaryAndBenefits">
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>مسئولیت های شما‌:</label>
                        <input class="form-control" type="text" v-model="workHistory.responsibilities">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3">
                    <div class="form-group">
                        <label>تلفن تماس:</label>
                        <input class="form-control" type="text" v-model="workHistory.phoneNumber">
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="form-group">
                        <label class="d-block">آیا مجاز به تماس هستیم؟</label>
                        <div class="d-inline-block">
                            <input class="custom-input-button" type="radio" v-model="workHistory.canContact" value="true" :id="'call'+index">
                            <label :for="'call'+index">بلی</label>
                        </div>
                        <div class="d-inline-block">
                            <input class="custom-input-button" type="radio" v-model="workHistory.canContact" value="false" :id="'dont-call'+index">
                            <label :for="'dont-call'+index">خیر</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { required } from "vuelidate/lib/validators";
    export default {
        data() {
            return {
                educationInfos: [
                    {
                        instituteName: "",
                        degree: "",
                        fieldOfStudy: "",
                        startDate: "",
                        endDate: "",
                        rate: null
                    }
                ],
                workHistories: [
                    {
                        companyName: "",
                        companyFieldOfActivity: "",
                        employeesCount: null,
                        post: "",
                        startOfWork: "",
                        endOfWork: "",
                        bossName: "",
                        primarySalaryAndBenefits: null,
                        lastSalaryAndBenefits: null,
                        responsibilities: "",
                        reasonOfTerminationOfCooperation: "",
                        phoneNumber: "",
                        canContact: true
                    },
                    {
                        companyName: "",
                        companyFieldOfActivity: "",
                        employeesCount: null,
                        post: "",
                        startOfWork: "",
                        endOfWork: "",
                        bossName: "",
                        primarySalaryAndBenefits: null,
                        lastSalaryAndBenefits: null,
                        responsibilities: "",
                        reasonOfTerminationOfCooperation: "",
                        phoneNumber: "",
                        canContact: true
                    }
                ],
            }
        },
        validations: {
            educationInfos: {
                $each: {
                    instituteName: { required },
                    degree: { required },
                    fieldOfStudy: { required },
                    startDate: { required },
                    endDate: { required },
                    rate: { required }
                }
            },
            workHistories: [],
            form: ['educationInfos', 'workHistories']
        },
        methods: {
            validate() {
                this.$v.form.$touch();
                var isValid = !this.$v.form.$invalid;
                this.$emit('on-validate', this.$data, isValid);
                return isValid
            },
            addNewEducationInfoRow() {
                const educationInfo = {
                    instituteName: "",
                    degree: "",
                    fieldOfStudy: "",
                    startDate: "",
                    endDate: "",
                    rate: null
                };
                this.educationInfos.push(educationInfo);
            },
            removeEducationInfoRow(index) {
                this.educationInfos.splice(index, 1);
            },
            addWorkHistory() {
                const workHistory = {
                    companyName: "",
                    companyFieldOfActivity: "",
                    employeesCount: null,
                    post: "",
                    startOfWork: "",
                    endOfWork: "",
                    bossName: "",
                    primarySalaryAndBenefits: null,
                    lastSalaryAndBenefits: null,
                    responsibilities: "",
                    reasonOfTerminationOfCooperation: "",
                    phoneNumber: "",
                    canContact: true
                };
                this.workHistories.push(workHistory);
            },
            removeWorkHistory() {
                this.workHistories.splice(2, 1);
            }
        }
    }
</script>